export default function openWindow(url: string) {
  window.open(
    url,
    '_blank',
    'location=yes,height=570,width=520,scrollbars=yes,status=yes',
  );
}
